module.exports = __webpack_public_path__ + "img/banner.fb436663.png";